/*************************************************
 * API Configuration (TypeScript)
 *************************************************/

export const API_HOST = '' as const;

export type EndpointBuilder = (id: string) => string;

export interface ApiEndpoints {
  WAN22_I2V_CREATE: string;
  WAN22_I2V_STATUS: EndpointBuilder;
  WAN22_I2V_RESULT: EndpointBuilder;
  WAN22_I2V_CANCEL: EndpointBuilder;

  WAN22_T2V_CREATE: string;
  WAN22_T2V_STATUS: EndpointBuilder;
  WAN22_T2V_RESULT: EndpointBuilder;
  WAN22_T2V_CANCEL: EndpointBuilder;

  WAN22_S2V_CREATE: string;
  WAN22_S2V_STATUS: EndpointBuilder;
  WAN22_S2V_RESULT: EndpointBuilder;
  WAN22_S2V_CANCEL: EndpointBuilder;

  WAN22_EXTEND_CREATE: string;
  WAN22_EXTEND_STATUS: EndpointBuilder;
  WAN22_EXTEND_RESULT: EndpointBuilder;
  WAN22_EXTEND_CANCEL: EndpointBuilder;

  TTS_CREATE: string;
  TTS_STATUS: EndpointBuilder;
  TTS_RESULT: EndpointBuilder;
  TTS_CANCEL: EndpointBuilder;

  // Virtual influencer TTS (new gateway-backed endpoints)
  VIRTUAL_TTS_CREATE: string;
  VIRTUAL_TTS_STATUS: EndpointBuilder;
  VIRTUAL_TTS_RESULT: EndpointBuilder;
  VIRTUAL_TTS_CANCEL: EndpointBuilder;

  VIDEO_UPSCALE_CREATE: string;
  VIDEO_UPSCALE_STATUS: EndpointBuilder;
  VIDEO_UPSCALE_RESULT: EndpointBuilder;
  VIDEO_UPSCALE_CANCEL: EndpointBuilder;

  SINGING_PHOTO_CREATE: string;
  SINGING_PHOTO_STATUS: EndpointBuilder;
  SINGING_PHOTO_RESULT: EndpointBuilder;
  SINGING_PHOTO_CANCEL: EndpointBuilder;

  SINGING_PHOTO_ZERO_CREATE: string;
  SINGING_PHOTO_ZERO_STATUS: EndpointBuilder;
  SINGING_PHOTO_ZERO_RESULT: EndpointBuilder;
  SINGING_PHOTO_ZERO_CANCEL: EndpointBuilder;
}

export const API_ENDPOINTS: ApiEndpoints = {
  WAN22_I2V_CREATE: '/api/v1/wan22/i2v',
  WAN22_I2V_STATUS: (taskId: string) => `/api/v1/wan22/i2v/${taskId}/status`,
  WAN22_I2V_RESULT: (taskId: string) => `/api/v1/wan22/i2v/${taskId}`,
  WAN22_I2V_CANCEL: (taskId: string) => `/api/v1/wan22/i2v/${taskId}/cancel`,

  WAN22_T2V_CREATE: '/api/v1/wan22/t2v',
  WAN22_T2V_STATUS: (taskId: string) => `/api/v1/wan22/t2v/${taskId}/status`,
  WAN22_T2V_RESULT: (taskId: string) => `/api/v1/wan22/t2v/${taskId}`,
  WAN22_T2V_CANCEL: (taskId: string) => `/api/v1/wan22/t2v/${taskId}/cancel`,

  WAN22_S2V_CREATE: '/api/v1/wan22/s2v',
  WAN22_S2V_STATUS: (taskId: string) => `/api/v1/wan22/s2v/${taskId}/status`,
  WAN22_S2V_RESULT: (taskId: string) => `/api/v1/wan22/s2v/${taskId}`,
  WAN22_S2V_CANCEL: (taskId: string) => `/api/v1/wan22/s2v/${taskId}/cancel`,

  WAN22_EXTEND_CREATE: '/api/v1/wan22/extend',
  WAN22_EXTEND_STATUS: (taskId: string) => `/api/v1/wan22/extend/${taskId}/status`,
  WAN22_EXTEND_RESULT: (taskId: string) => `/api/v1/wan22/extend/${taskId}`,
  WAN22_EXTEND_CANCEL: (taskId: string) => `/api/v1/wan22/extend/${taskId}/cancel`,

  TTS_CREATE: '/api/v1/tts',
  TTS_STATUS: (taskId: string) => `/api/v1/tts/${taskId}/status`,
  TTS_RESULT: (taskId: string) => `/api/v1/tts/${taskId}`,
  TTS_CANCEL: (taskId: string) => `/api/v1/tts/${taskId}/cancel`,

  // Virtual influencer TTS (new gateway-backed endpoints)
  VIRTUAL_TTS_CREATE: '/api/virtual-influencer-tts',
  VIRTUAL_TTS_STATUS: (taskId: string) => `/api/virtual-influencer-tts/${taskId}/status`,
  VIRTUAL_TTS_RESULT: (taskId: string) => `/api/virtual-influencer-tts/${taskId}`,
  VIRTUAL_TTS_CANCEL: (taskId: string) => `/api/virtual-influencer-tts/${taskId}/cancel`,

  VIDEO_UPSCALE_CREATE: '/api/v1/video/upscale',
  VIDEO_UPSCALE_STATUS: (taskId: string) => `/api/v1/video/upscale/${taskId}/status`,
  VIDEO_UPSCALE_RESULT: (taskId: string) => `/api/v1/video/upscale/${taskId}`,
  VIDEO_UPSCALE_CANCEL: (taskId: string) => `/api/v1/video/upscale/${taskId}/cancel`,

  SINGING_PHOTO_CREATE: '/api/v1/fal/queue/singing-photo',
  SINGING_PHOTO_STATUS: (taskId: string) => `/api/v1/fal/queue/singing-photo/requests/${taskId}/status`,
  SINGING_PHOTO_RESULT: (taskId: string) => `/api/v1/fal/queue/singing-photo/requests/${taskId}`,
  SINGING_PHOTO_CANCEL: (taskId: string) => `/api/v1/fal/queue/singing-photo/requests/${taskId}/cancel`,

  SINGING_PHOTO_ZERO_CREATE: '/api/v1/fal/queue/singing-photo-zero',
  SINGING_PHOTO_ZERO_STATUS: (taskId: string) => `/api/v1/fal/queue/singing-photo-zero/requests/${taskId}/status`,
  SINGING_PHOTO_ZERO_RESULT: (taskId: string) => `/api/v1/fal/queue/singing-photo-zero/requests/${taskId}`,
  SINGING_PHOTO_ZERO_CANCEL: (taskId: string) => `/api/v1/fal/queue/singing-photo-zero/requests/${taskId}/cancel`,
};

export interface ApiConfig {
  host: string;
  endpoints: ApiEndpoints;
  getFullUrl: (endpoint: string) => string;
}

const apiConfig: ApiConfig = {
  host: API_HOST,
  endpoints: API_ENDPOINTS,
  getFullUrl: (endpoint: string) => `${API_HOST}${endpoint}`,
};

export default apiConfig;
